import React from 'react';

import { object, number, string } from 'yup';
import startCase from 'lodash/startCase';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FieldsBadgessList from './FieldBadgesList.jsx';

const defaults = {
  name: '',
  mint: '',
  owner: '',
  address: '',
  horseId: 0,
  bloodline: '',
  breedType: '',
  gender: '',
  gxeEarned: 0,

  racingCount: 0,
  breedingCount: 0,
  trainingCount: 0,
  rentingCount: 0,

  // explosiveOneTime: '',
  // winnerBadges: '',
  skill: {
    gate: 0,
    distance: 0,
    traction: 0,
    lucky: 0,
    mutation: 1,
    runStyle: 0,
  },
  clsLv: 1,
  expLv: 1,
  stamina: 12,
  staminaMax: 12,
  winnerResult: 0,
  winRate: 0,
  placeRate: 0,
  badges: [],
  racing: {
    explosiveness: 0,
    competitiveness: 0,
    toughness: 0,
    agility: 0,
    focus: 0,
    power: 0,
  },
  training: {
    explosiveness: 0,
    competitiveness: 0,
    toughness: 0,
    agility: 0,
    focus: 0,
    power: 0,
    maxPoint: 0,
    totalSpent: {
      dge: 0,
      gxe: 0,
    },
  },
  joinRaceToken: 0,
};

const skillsMap = {
  gate: {
    0: '1-4',
    1: '5-8',
    2: '9-12',
  },
  distance: {
    0: 'short',
    1: 'middle',
    2: 'long',
  },
  traction: {
    0: 'wet',
    1: 'dry',
    2: 'sand',
  },
  lucky: {
    0: 'low',
    1: 'middle',
    2: 'high',
  },
  mutation: {
    5: 'A',
    4: 'B',
    3: 'C',
    2: 'D',
    1: 'E',
  },
  runStyle: {
    0: 'start',
    1: 'middle',
    2: 'end',
  },
};

function getSkillValue(skill) {
  if (skill) {
    Object.keys(skill).forEach((k) => {
      var v = skill[k];
      skill[k] = skillsMap[k][v];
    });
  }
  return skill;
}

const FormHorse = ({ horse, enable = true }) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        winnerResult: number().min(0),
        winRate: number().min(0),
        placeRate: number().min(0),
      }),
      stored: horse ? {
        ...horse,
        skill: enable ? horse.skill : getSkillValue(horse.skill),
      } : undefined,
      api: '/api/site/horses',
      options: {omitIds: false},
    }}
  >

    <div className="form-row">
      <div className="col">
      <FormGroup name="horseId" label="Horse ID" disabled/>
      </div>
      <div className="col">
        <FormGroup name="bloodline" disabled />
      </div>
      <div className="col">
        <FormGroup name="breedType" disabled />
      </div>
      <div className="col">
        <FormGroup name="gender" disabled />
      </div>
    </div>

    <div className="form-row">
      <div className="col">
        <FormGroup name="name" label="Name" disabled />
      </div>
      <div className="col">
        <FormGroup name="mint" disabled />
      </div>
      <div className="col">
        <FormGroup name="owner" />
      </div>
      <div className="col">
        <FormGroup name="joinRaceToken" type='number' min={0} disabled={!enable}/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="gxeEarned" type='number' min={0} label="GXE Earned" disabled={!enable}/>  
      </div>
      <div className="col">
      <FormGroup name="winnerResult" type='number' min={0} label="Winner Result" disabled={!enable}/>
      </div>
      <div className="col">
      <FormGroup name="winRate" type='number' min={0} disabled={!enable}/>  
      </div>
      <div className="col">
      <FormGroup name="placeRate" type='number' min={0} disabled={!enable}/>  
      </div>
    </div>

    <div className="form-row">
      <div className="col">
      <FormGroup name="racingCount" type='number' min={0} label="Racing" disabled={!enable}/>  
      </div>
      <div className="col">
      <FormGroup name="breedingCount" type='number' min={0} label="Breeding" disabled={!enable}/>
      </div>
      <div className="col">
      <FormGroup name="trainingCount" type='number' min={0} label="Training" disabled={!enable}/>  
      </div>
      <div className="col">
      <FormGroup name="rentingCount" type='number' min={0} label="Renting" disabled={!enable}/>  
      </div>
    </div>

    <div className="form-group">
      <h5>Skills</h5>
      <div className="form-row">
        <div className="col">
          {enable ? (
          <FormGroup name="clsLv" label="Class Level" as="select">
            {Array(6).fill().map((_, i) => i+1).map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </FormGroup>
          ): (
          <FormGroup name="clsLv" label="Class Level"  disabled/>
          )}
        </div>
        <div className="col">
          {enable ? (
          <FormGroup name="expLv" label="Exp Level" as="select">
            {Array(30).fill().map((_, i) => i+1).map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </FormGroup>
          ): (
          <FormGroup name="expLv" label="Exp Level"  disabled/>
          )}
        </div>
        <div className="col">
          {enable ? (
          <FormGroup name="stamina" label="Stamina" as="select">
            {Array(31).fill().map((_, i) => i).map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </FormGroup>
          ) : (
          <FormGroup name="stamina" label="Stamina"  disabled/>
          )}
        </div>
        <div className="col">
          {enable ? (
          <FormGroup name="staminaMax" label="Stamina (MAX)" as="select">
            {Array(30-11).fill().map((_, i) => (i+12)).map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </FormGroup>
          ) : (
          <FormGroup name="staminaMax" label="Stamina (MAX)"  disabled/>
          )}
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.distance"
              label="Distance"
              as="select">
              {Object.keys(skillsMap.distance).map((a) => (
              <option key={a} value={a}>{skillsMap.distance[a]}</option>
            ))}
          </FormGroup>
          ) : (
            <FormGroup
              name="skill.distance"
              label="Distance"
              disabled
            />
          )}
        </div>
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.traction"
              label="Traction"
              as="select">
              {Object.keys(skillsMap.traction).map((a) => (
                <option key={a} value={a}>
                  {skillsMap.traction[a]}
                </option>
              ))}
            </FormGroup>
          ) : (
            <FormGroup
              name="skill.traction"
              label="Traction"
              disabled
            />
          )}
        </div>
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.gate"
              label="Gate"
              as="select">
              {Object.keys(skillsMap.gate).map((a) => (
                <option key={a} value={a}>
                  {skillsMap.gate[a]}
                </option>
              ))}
            </FormGroup>
          ) : (
            <FormGroup
              name="skill.gate"
              label="Gate"
              disabled
            />
          )}
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.runStyle"
              label="Run Style"
              as="select">
              {Object.keys(skillsMap.runStyle).map((a) => (
                <option key={a} value={a}>
                  {skillsMap.runStyle[a]}
                </option>
              ))}
            </FormGroup>
          ) : (
            <FormGroup
              name="skill.runStyle"
              label="Run Style"
              disabled
            />
          )}
        </div>
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.lucky"
              label="Lucky"
              as="select">
              {Object.keys(skillsMap.lucky).map((a) => (
                <option key={a} value={a}>
                  {skillsMap.lucky[a]}
                </option>
              ))}
            </FormGroup>
          ) : (
            <FormGroup
              name="skill.lucky"
              label="Lucky"
              disabled
            />
          )}
        </div>
        <div className="col">
          {enable ? (
            <FormGroup
              name="skill.mutation"
              label="Mutation"
              as="select">
              {Object.keys(skillsMap.mutation).map((a) => (
                <option key={a} value={a}>
                  {skillsMap.mutation[a]}
                </option>
              ))}
            </FormGroup>
          ) : (
            <FormGroup
              name="skill.mutation"
              label="Mutation"
              disabled
            />
          )}
        </div>
      </div>
    </div>
    <div className="form-group">
      <h5>Abilities</h5>
      <div className="form-row">
        {Object.keys(defaults.racing).map((a) => (
          <div className="col" key={a}>
            <FormGroup
              name={`racing.${a}`}
              type="number"
              min={0}
              max={100}
              label={startCase(a)}
              disabled={!enable}
            />
          </div>
        ))}
      </div>
      <div className="form-row">
        {Object.keys(defaults.racing).map((a) => (
          <div className="col" key={a}>
            <FormGroup
              name={`training.${a}`}
              type="number"
              min={0}
              max={5}
              label={null}
              disabled={!enable}
            />
          </div>
        ))}
      </div>
      <div className="form-row">
        <div className="col">
          <FormGroup
            name="training.totalSpent.gxe"
            label="Training Total Spent (GXE)"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup
            name="training.totalSpent.dge"
            label="Training Total Spent (DGE)"
            disabled
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          <FormGroup
            name="training.maxPoint"
            type="number"
            min={0}
            label="Max. badge points"
            disabled={!enable}
          />
        </div>
      </div>
    </div>

    <div className="form-group">
      <h5>Badges</h5>
      <FieldsBadgessList />
    </div>
    {/* <div className="form-row">
      <div className="col">
        <FormGroup name="explosiveOneTime" label="Explosive one time" />
      </div>
      <div className="col">
        <FormGroup name="winnerBadges" label="Winner Badges" />
      </div>
    </div> */}
  </FormResource>
);

export default FormHorse;
